import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import { ALPHABETICAL_SORT } from "components/common/PaginatedEntityTable/slicing/slicingConstants";
import TagsFilter from "components/events/TagsFilter";
export const EVENTS_ENTITY_TABLE_ID = "events";
export const nonInfoPriorities = Object.keys(EventDefinitionPriorityEnum.properties).reverse().filter((key) => key !== String(EventDefinitionPriorityEnum.INFO));
export const commonEventAttributes = [
  {
    filter_options: [
      ...Object.keys(EventDefinitionPriorityEnum.properties).reverse().map((num) => ({ value: num, title: num }))
    ],
    filterable: true,
    id: "priority",
    searchable: false,
    sliceable: true,
    sortable: true,
    title: "Priority",
    type: "STRING",
    slice_sort_default: { mode: ALPHABETICAL_SORT, direction: "desc" }
  },
  {
    id: "timestamp",
    title: "Timestamp",
    type: "DATE",
    sortable: true,
    filterable: true
  },
  {
    id: "event_definition_id",
    title: "Event Definition",
    type: "STRING",
    sortable: false,
    searchable: false,
    filterable: true,
    related_collection: "event_definitions"
  },
  {
    id: "event_definition_type",
    title: "Event Definition Type",
    type: "STRING",
    sortable: true
  },
  {
    id: "key",
    title: "Key",
    type: "STRING",
    sortable: true,
    searchable: false
  },
  {
    id: "group_by_fields",
    title: "Group-By Fields",
    sortable: false
  }
];
export const detailsAttributes = [
  ...commonEventAttributes,
  {
    id: "remediation_steps",
    title: "Event Procedures",
    hidden: true,
    sortable: false
  },
  {
    id: "timerange_start",
    title: "Aggregation time range",
    sortable: true,
    type: "DATE",
    filterable: true
  },
  {
    id: "id",
    title: "ID",
    type: "STRING",
    sortable: true,
    searchable: true,
    filterable: true
  },
  {
    id: "fields",
    title: "Additional Fields",
    type: "STRING",
    sortable: false
  }
];
export const eventsTableSpecificAttributes = [
  {
    id: "message",
    title: "Description",
    type: "STRING",
    sortable: false,
    searchable: false
  },
  {
    id: "alert",
    title: "Type",
    type: "BOOLEAN",
    sortable: true,
    sliceable: true,
    filterable: true,
    filter_options: [
      { value: "false", title: "Event" },
      { value: "true", title: "Alert" }
    ]
  },
  {
    id: "tags",
    title: "Tags",
    type: "STRING",
    sortable: false,
    filterable: true,
    filter_component: TagsFilter
  }
];
export const additionalAttributes = [...eventsTableSpecificAttributes, ...detailsAttributes];
export const eventsTableElements = {
  defaultLayout: {
    entityTableId: EVENTS_ENTITY_TABLE_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: "timestamp", direction: "desc" },
    defaultDisplayedAttributes: [
      "timestamp",
      "alert",
      "priority",
      "message",
      "event_definition_id",
      "key",
      "event_definition_type"
    ],
    defaultColumnOrder: [
      "timestamp",
      "alert",
      "priority",
      "message",
      "event_definition_id",
      "key",
      "event_definition_type",
      "group_by_fields",
      "remediation_steps",
      "id",
      "tags",
      "fields",
      "timerange_start"
    ]
  }
};
export const REPLAY_SESSION_ID_PARAM = "replaySessionId";
